import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';

import BlockSingleComponent from 'webapp/components/block/single';
import type { CustomMetricSetupForm } from 'webapp/components/custom-query/setup/common/form';

interface Args {
	form: CustomMetricSetupForm;
}

export default class CustomQuerySetupCommonPreviewChartComponent extends Component<Args> {
	@service('constants') declare constantsService: Service.Constants;
	@service('model-manager/boards') declare mmBoardsService: Service.ModelManager.Boards;

	get boardState() {
		return this.args.form.boardState;
	}

	get block() {
		return this.args.form.previewBlock;
	}

	get skipBlockFetchLoader() {
		return !this.args.form.isLoadingPreview;
	}

	get colorConfig() {
		const blockColor = this.constantsService.defaultBoardColor;
		return this.mmBoardsService.getColorConfig(blockColor, 1);
	}
	<template>
		<div class="view-single-block-wrapper">
			<BlockSingleComponent
				@boardState={{this.boardState}}
				@colorConfig={{this.colorConfig}}
				@showBg={{true}}
				@extraClasses={{unless this.block.sample "loading"}}
				@skipBlockFetchLoader={{this.skipBlockFetchLoader}}
			/>
		</div>
	</template>
}
